import { Injectable } from '@angular/core';

import { ClientConfig, ClientConfigProductName, ClientConfigService } from '@frontend/vanilla/core';

/*
 * @see {@link https://admin.dynacon.prod.env.works/services/263833/features/492904 DynaCon config}
 */
@ClientConfig({ key: 'vnTracing', product: ClientConfigProductName.SF })
@Injectable({
    providedIn: 'root',
    useFactory: configFactory,
    deps: [ClientConfigService],
})
export class TracingConfig {
    url: string;
    allowedUrlPatterns: string[];
}

export function configFactory(service: ClientConfigService) {
    return service.get(TracingConfig);
}
